export default __webpack_public_path__ + "media/images/arrow-right-dae7d068a5eb2861c07562e1aced8df1.png";